import React from "react";
import { List } from "@refinedev/mui";
import { IResourceComponentsProps } from "@refinedev/core";
import { IGrantVestment } from "interfaces/grant-vestment";
import { InfiniteList } from "components/list/infinity-list";
import { shortFormat } from "utils/date-format";
import { moneyFormat } from "utils/money-format";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { ActionButton, ActionMenuItem } from "components/action-button";

export const ArchivedGrantVestmentList: React.FC<IResourceComponentsProps> = () => {
  return (
    <>
      <List
        title="Archived GrantVestments"
        wrapperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
            padding: 2,
          },
        }}
      >
        <InfiniteList<IGrantVestment>
          endpoint="grant-vestments"
          limit={10}
          queryParams={{ "filter[status]": ["ARCHIVED"] }}
          isTable={true}
          columns={[
            {
              field: "name",
              header: "Name",
            },
            {
              field: "projectBy",
              header: "Projected By",
            },
            {
              header: "Goal",
              renderCell: function render({ goalAmount }) {
                return `${moneyFormat(goalAmount)}`;
              },
            },
            {
              header: "GrantVestors",
              renderCell: function render({ grantVestorCounter }) {
                return `${grantVestorCounter} Investors`;
              },
            },
            {
              field: "status",
              header: "Status",
            },
            {
              header: "Deadline",
              renderCell: function render({ deadline }) {
                return shortFormat(deadline);
              },
            },
            {
              field: "status",
              header: "status",
            },
            {
              header: "Actions",
              renderCell: function render({ grantVestmentId }) {
                const menuItems: ActionMenuItem[] = [
                  {
                    name: "View",
                    icon: <VisibilityOutlinedIcon sx={{ fontSize: 20 }} />,
                    navigateUrl: (id) => `/grant-vestments/archived/${id}`,
                  },
                ];

                return <ActionButton id={grantVestmentId} menuItems={menuItems} />;
              },
            },
          ]}
          tableProps={{
            stickyHeader: true,
            headerBgColor: "grey.200",
            responsive: true,
          }}
          searchConfig={{
            enabled: true,
            placeholder: "Search GrantVestment...",
            searchField: "searchTerm",
          }}
          emptyMessage={`No Archived GrantVestment found!`}
        />
      </List>
    </>
  );
};
